import { render } from "./ThePromoEvent.vue?vue&type=template&id=15d54b58&scoped=true&ts=true&lang=html"
import script from "./ThePromoEvent.vue?vue&type=script&lang=ts"
export * from "./ThePromoEvent.vue?vue&type=script&lang=ts"

import "./ThePromoEvent.vue?vue&type=style&index=0&id=15d54b58&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d54b58"]])

export default __exports__